import { PublicClientApplication } from '@azure/msal-browser';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { MsalProvider } from '@azure/msal-react';
import { Provider } from 'react-redux';

import store from "./configureStore";
import { ThemeContextProvider } from './ThemeContext';

import './App.css';
import { msalConfig } from './authConfig';
import OperationsApp from './OperationsApp';

function App() {
    const msalInstance = new PublicClientApplication(msalConfig);
    msalInstance.initialize();

    return (
        <ThemeContextProvider>
            <MsalProvider instance={msalInstance}>
                <LocalizationProvider dateAdapter={AdapterLuxon}>
                    <Provider store={store}>
                        <OperationsApp />
                    </Provider>
                </LocalizationProvider>
            </MsalProvider>
        </ThemeContextProvider>
    );
}

export default App;
